import React, {Component} from "react";
import Loading from "../../Containers/Loading";
import Header from "../../Containers/Header/Header";
import Footer from "../../Containers/Footer";
import * as OnlinService from '../../../services/Online/OnlineService';
import ReactPlayer from "react-player";

const initState = {
    // loading
    isLoadingHide: false,
    onlineList: [],
    srcVideo: ''
};

class Online extends Component {
    state = {
        // loading
        isLoadingHide: false,
        onlineList: [],
        srcVideo: ''
    };

    constructor() {
        super();
        this.videoRef = React.createRef();
    }

    componentDidMount = () => {
        this.setState({
            isLoadingHide: true
        });
        this.getVideoList();
    };

    getVideoList = () => {
        OnlinService.getVideoList().then((response) => {
            if (response !== null && response.status === 200) {
                let linkedHashMap = response.data.data;
                let onlineList = [];
                Object.keys(response.data.data).forEach(item => {
                    let online = {
                        classroomName: item,
                        videoList: linkedHashMap[item]
                    };
                    onlineList.push(online);
                });
                this.setState({onlineList: onlineList});
            }
        }).catch((error) => {
            console.log(error);
            alert('SERVER ERROR');
        });
    };

    whatToPlayVideo = (path) => {
        this.setState({srcVideo: path});
    };

    render() {
        let listClassRoomName = this.state.onlineList.map((item, key) => {
            let videoList = item.videoList.map((video, key) => {
                let videoUrlSplit = video.split('/');
                return (<li key={video + key} onClick={() => this.whatToPlayVideo(video)}
                           style={{marginLeft: '2%', marginTop: '2%', cursor: 'pointer', fontSize: '15pt'}}>
                    {videoUrlSplit[videoUrlSplit.length - 1].split('.')[0]}
                    <span style={{marginLeft:'1%'}}> 영상 보려면 여기 클릭!</span>
                </li>)
            });
            return (
                <li key={item + key}>
                    <span style={{display: 'block', fontSize: '30pt', fontWeight: 'bold'}}>
                        {item.classroomName}
                    </span>
                    <ul>
                        {videoList}
                    </ul>
                </li>
            );
        });
        if (!this.state.isLoadingHide) {
            return (<Loading/>);
        }
        return (
            <div className="beaconWrapper">
                <Header selectedIndex={2}/>
                <div className="allconWrapper">
                    <div className="contentsWrapper">
                        <div style={{marginLeft: '5%', marginTop: '2%', display: 'block'}}>
                            <ul style={{marginLeft: '5%', marginTop: '1%', listStyleType: 'circle'}}>
                                {listClassRoomName}
                            </ul>
                        </div>
                        <div>
                            {this.state.srcVideo !== ''
                                ? (<div style={{marginLeft: '5%', marginTop: '5%', width: 'auto', height: 'auto'}}>
                                    <ReactPlayer
                                        url={this.state.srcVideo}
                                        width='80%'
                                        height='100%'
                                        playing
                                        controls
                                    />
                                </div>)
                                : (<div></div>)
                            }
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
        );
    }
}

export default Online;



// WEBPACK FOOTER //
// ./src/components/Pages/Online/index.js